export default {
  ADD(state, map) {
    state.Cache = { ...state.Cache, ...map }
  }
}
